export default __webpack_public_path__ + "static/media/signin_img.e45c7982.png";